import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
export const RoleRoute = ({ children, roles }) => {
    const user = useAppSelector((state) => state.auth.user);
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (!roles.includes(user.role)) {
        return _jsx(Navigate, { to: "/app", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
